import * as constants from '@/utils/analytics/constants/constants'

export const PRODUCT_MODEL_SECTION = constants.PRODUCT_MODEL

export const PRODUCT_MODEL_CHANGED = `${ PRODUCT_MODEL_SECTION }_changed`
export const PRODUCT_MODEL_LOADED = `${ PRODUCT_MODEL_SECTION }_loaded`
export const PRODUCT_MODEL_OPENED_SETTINGS = `${ PRODUCT_MODEL_SECTION }_settings`
export const PRODUCT_MODEL_EXPORTED_EXCEL = `main_${ PRODUCT_MODEL_SECTION }_loaded_excel`
export const PRODUCT_MODEL_SAVED_VALIDATION = `${ PRODUCT_MODEL_SECTION }_saved_validation`
